import Cookies from 'js-cookie'
import { sendToNative } from '@mobi/web-native-comms/web'

export function getCookieValue(cookieName: string): string | undefined {
  return Cookies.get(cookieName)
}

export function setCookieValue(
  cookieName: string,
  value: string,
  options?: Cookies.CookieAttributes
) {
  Cookies.set(cookieName, value, options)
}

/// Safely remove a cookie from both the web and native side. Setting a
/// cookie is synced automatically, but removing needs an explicit call
export function clearCookieValue(cookieName: string) {
  Cookies.remove(cookieName)
  sendToNative('CLEAR_NATIVE_COOKIE', { name: cookieName })
}
